<template>
    <div>
        <user-action-revoke-dialog
            :activatorType="activatorType"
            :showRevokeButton="showRevokeButton"
            :ucid="ucid"
            :userName="userName"
            :hierarchicalLevel="hierarchicalLevel"
            :role="role"
            :reason="reason"
            :spaceAdmin="spaceAdmin"
            :instanceName="instanceName"
            :instanceId="instanceId"
            :spaceName="spaceName"
            :orgName="orgName"
            @close-menu="$emit('close-menu')"></user-action-revoke-dialog>
    </div>
</template>

<script>
const UserActionRevokeDialog = () => import('@/components/UserActionRevokeDialog.vue')

export default {
    name: 'UserActions',
    components: {
        UserActionRevokeDialog
    },
    props: {
        ucid: String,
        userName: String,
        hierarchicalLevel: String,
        role: String,
        reason: {
            type: String,
            default: null
        },
        spaceAdmin: {
            type: Boolean,
            default: null
        },
        showRevokeButton: {
            type: Boolean,
            default: true
        },
        activatorType: {
            type: String,
            default: 'icon'
        },
        instanceName: {
            type: String,
            default: null
        },
        instanceId: {
            type: String,
            default: null
        },
        spaceName: {
            type: String,
            default: null
        },
        orgName: {
            type: String,
            default: null
        }
    }
}
</script>
